'use client';

import { useEffect } from 'react';

import { Button } from '@/components/ui/button';
import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface ErrorPageProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorPageProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-full flex-1 items-center justify-center px-4 py-10">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
          <CardDescription>
            An unexpected error occurred. You can try again or return later.
          </CardDescription>
        </CardHeader>
        <div className="flex flex-col gap-3">
          {error.digest ? (
            <p className="text-xs text-[var(--color-muted)]">Error ID: {error.digest}</p>
          ) : null}
          <Button onClick={reset}>Try again</Button>
        </div>
      </Card>
    </div>
  );
}
